import { Mail, Phone, MapPin } from "lucide-react";

const QuoteInfoSection = ({ quote, calculateAcres, calculateTotalAcres }) => {
  const polygons = quote.polygon_data
    ? Array.isArray(quote.polygon_data)
      ? quote.polygon_data
      : [quote.polygon_data]
    : [];

  return (
    <div className="grid md:grid-cols-2 gap-8 p-8 border-b border-zinc-200">
      {/* Customer */}
      <div>
        <h3 className="font-heading text-lg font-bold uppercase tracking-tight text-[#00341d] mb-4">
          Customer
        </h3>
        <div className="space-y-2">
          <p className="font-semibold text-lg text-zinc-900">{quote.customer_name}</p>
          {quote.customer_email && (
            <p className="text-zinc-600 flex items-center gap-2">
              <Mail className="w-4 h-4 text-zinc-400" />
              {quote.customer_email}
            </p>
          )}
          {quote.customer_phone && (
            <p className="text-zinc-600 flex items-center gap-2">
              <Phone className="w-4 h-4 text-zinc-400" />
              {quote.customer_phone}
            </p>
          )}
        </div>
      </div>

      {/* Property */}
      <div>
        <h3 className="font-heading text-lg font-bold uppercase tracking-tight text-[#00341d] mb-4">
          Property Location
        </h3>
        {quote.property_address && (
          <p className="text-zinc-600 flex items-center gap-2 mb-2">
            <MapPin className="w-4 h-4 text-zinc-400" />
            {quote.property_address}
          </p>
        )}
        {quote.parcel_pin && (
          <p className="text-zinc-500 text-sm mb-2">PIN: {quote.parcel_pin}</p>
        )}

        {/* Additional Properties */}
        {quote.additional_properties && quote.additional_properties.length > 0 && (
          <div className="mt-4 pt-4 border-t border-zinc-200">
            <p className="text-sm font-medium text-zinc-500 mb-2">Additional Properties:</p>
            <div className="space-y-2">
              {quote.additional_properties.map((prop, index) => (
                <div key={prop.pin || prop.address || index} className="flex items-start gap-2">
                  <MapPin className="w-4 h-4 text-zinc-400 mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="text-zinc-600 text-sm">{prop.address}</p>
                    {prop.pin && <p className="text-zinc-400 text-xs">PIN: {prop.pin}</p>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Acreage summary */}
        {polygons.length > 0 && (
          <div className="mb-4">
            <div className="bg-green-50 border border-green-200 rounded-lg p-3">
              <div className="flex items-center justify-between">
                <span className="text-sm text-green-700">Total Area</span>
                <span className="font-bold text-green-800">
                  {calculateTotalAcres(polygons).toFixed(2)} acres
                </span>
              </div>
              {polygons.length > 1 && (
                <div className="mt-2 pt-2 border-t border-green-200 space-y-1">
                  {polygons.map((poly, idx) => (
                    <div key={`area-${idx}`} className="flex justify-between text-xs text-green-600">
                      <span>{poly._name || `Area ${idx + 1}`}</span>
                      <span>{calculateAcres(poly).toFixed(2)} ac</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuoteInfoSection;
